var _style, _rect, _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 85",
    style: {
      enableBackground: "new 0 0 283.5 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#6D6E71;}\r\n\t.st2{fill:#414042;}\r\n\t.st3{fill:#D7DF23;}\r\n\t.st4{fill:url(#SVGID_1_);}\r\n\t.st5{fill:url(#SVGID_00000152243417656455569880000002113312678171088556_);}\r\n\t.st6{fill:url(#SVGID_00000133495212665292214760000008205257986784971172_);}\r\n\t.st7{fill:url(#SVGID_00000098220710298956260310000016996042854772992402_);}\r\n\t.st8{fill:url(#SVGID_00000121251114840416687780000018179212276877502352_);}\r\n\t.st9{fill:url(#SVGID_00000052826415563049636570000010774358282604190399_);}\r\n\t.st10{fill:url(#SVGID_00000127746726757304915240000006241375045003807375_);}\r\n\t.st11{fill:url(#SVGID_00000169529879206582614350000000049375840137919909_);}\r\n\t.st12{fill:url(#SVGID_00000014603739273548285800000012388346149956275589_);}\r\n\t.st13{fill:url(#SVGID_00000044174206154875675680000005075327547997016475_);}\r\n\t.st14{fill:url(#SVGID_00000060738775633674214900000000610044039925024671_);}\r\n\t.st15{fill:url(#SVGID_00000080891395542174137720000008119699167380631729_);}\r\n\t.st16{fill:url(#SVGID_00000168797275421753254600000003003154519935745184_);}\r\n\t.st17{fill:url(#SVGID_00000179604167765853467150000005533712753023890836_);}\r\n\t.st18{fill:url(#SVGID_00000088822978118402398490000012862990730896886703_);}\r\n\t.st19{fill:url(#SVGID_00000129188828659601217110000014566114673176990380_);}\r\n\t.st20{fill:url(#SVGID_00000031926050155668749190000010023093588178904985_);}\r\n\t.st21{fill:url(#SVGID_00000176036971812373854380000004037201556640863407_);}\r\n\t.st22{fill:url(#SVGID_00000152235571560223948750000000757724083403559343_);}\r\n\t.st23{fill:url(#SVGID_00000080907336818296739090000012531342442887619003_);}\r\n\t.st24{fill:url(#SVGID_00000181767342273241756760000002452944145185514657_);}\r\n\t.st25{fill:url(#SVGID_00000095321280763889152390000001422264097292628619_);}\r\n\t.st26{fill:url(#SVGID_00000116946913389695155250000016093176721796564645_);}\r\n\t.st27{fill:url(#SVGID_00000097476879760693130750000011244140655996269205_);}\r\n\t.st28{fill:url(#SVGID_00000142161226502589609500000013186514032505119910_);}\r\n\t.st29{fill:url(#SVGID_00000067198734178993624020000008382264839305211045_);}\r\n\t.st30{fill:url(#SVGID_00000078732006734528654430000012503843088495970488_);}\r\n\t.st31{fill:url(#SVGID_00000129919635918471239170000012601091361145447818_);}\r\n\t.st32{fill:url(#SVGID_00000130623412357249289740000003755299816484280465_);}\r\n\t.st33{fill:url(#SVGID_00000010302450181528360470000008643761540218590619_);}\r\n\t.st34{fill:url(#SVGID_00000121268304634330541070000010811419830183473033_);}\r\n\t.st35{fill:url(#SVGID_00000078735074705651042040000015755802608239900048_);}\r\n\t.st36{fill:url(#SVGID_00000145034860856260687610000016497153499894052254_);}\r\n\t.st37{fill:url(#SVGID_00000053543864178408637750000004275106382869631927_);}\r\n\t.st38{fill:url(#SVGID_00000088130764039305295040000006134557827309717403_);}\r\n\t.st39{fill:url(#SVGID_00000103241409974371726450000017259715818986838459_);}\r\n\t.st40{fill:url(#SVGID_00000096776905367489621700000011819814758758655397_);}\r\n\t.st41{fill:url(#SVGID_00000088130744356851693210000014447090109252154531_);}\r\n\t.st42{fill:url(#SVGID_00000029020473757883594330000000513561104696976512_);}\r\n\t.st43{fill:url(#SVGID_00000033371162801590830150000002764957706505803176_);}\r\n\t.st44{fill:url(#SVGID_00000132790355269812439150000013809282503318379410_);}\r\n\t.st45{fill:url(#SVGID_00000090999652153262755060000001103680122288310930_);}\r\n\t.st46{fill:url(#SVGID_00000069376289041166256800000009861724715476607108_);}\r\n\t.st47{fill:url(#SVGID_00000106146624902879721770000003066796523004228238_);}\r\n\t.st48{fill:url(#SVGID_00000157274794390145533200000011617148536528206255_);}\r\n\t.st49{fill:url(#SVGID_00000139294071402513951540000013924275923573453968_);}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 36.7,
    className: "st0",
    width: 37.7,
    height: 33.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.8,77.6V59.1h4.4v14.5h7.2v4H255.8z M240.7,77.6V59.1h4.4v14.5h7.2v4H240.7z M230.6,77.6V59.1h4.4v18.4 H230.6z M209.2,77.6V59.1h4.4v6.8h7.1v-6.8h4.3v18.4h-4.3v-7.7h-7.1v7.7H209.2z M204.4,65c-0.8-0.8-1.6-1.4-2.4-1.8 c-0.8-0.4-1.7-0.6-2.6-0.6c-1.6,0-2.8,0.5-3.8,1.6c-1,1.1-1.5,2.5-1.5,4.1c0,1.7,0.5,3.1,1.5,4.1c1,1,2.3,1.6,3.8,1.6 c0.9,0,1.9-0.2,2.8-0.6c0.9-0.4,1.9-1,2.8-1.8l-0.3,4.9c-0.8,0.5-1.6,0.9-2.6,1.2c-0.9,0.3-1.9,0.4-2.9,0.4c-1.1,0-2.1-0.2-3.1-0.5 c-1-0.3-1.9-0.8-2.8-1.5c-1.2-0.9-2.1-2.1-2.7-3.4c-0.6-1.3-0.9-2.8-0.9-4.4c0-1.4,0.2-2.6,0.7-3.8c0.5-1.2,1.1-2.3,2-3.2 c0.9-0.9,1.9-1.6,3.1-2.1c1.2-0.5,2.4-0.7,3.7-0.7c1,0,2,0.1,3,0.4c0.9,0.3,1.8,0.7,2.7,1.3L204.4,65z M172.8,77.6V59.1h4.7 c1.5,0,2.7,0.1,3.5,0.3c0.8,0.2,1.6,0.5,2.2,1c0.7,0.5,1.2,1.1,1.6,1.8c0.4,0.7,0.6,1.5,0.6,2.3c0,1.2-0.3,2.2-0.9,3.1 c-0.6,0.9-1.4,1.6-2.6,2l5.6,7.9h-5l-4.9-7.2h-0.6v7.2H172.8z M177.8,62.5h-0.7v5.1h0.9c1.1,0,2-0.2,2.5-0.7 c0.6-0.4,0.9-1.1,0.9-1.9c0-0.9-0.3-1.5-0.9-1.9C180,62.7,179.1,62.5,177.8,62.5z M156.3,59.1v10.1c0,1.6,0.3,2.8,0.9,3.7 c0.6,0.8,1.5,1.2,2.7,1.2c1.2,0,2.1-0.4,2.7-1.1c0.6-0.8,0.9-1.8,0.9-3.3V59.1h3.9v10.6c0,2.7-0.7,4.7-2,6.2 c-1.4,1.5-3.3,2.2-5.7,2.2c-2.5,0-4.4-0.7-5.7-2.2c-1.4-1.5-2-3.6-2-6.2V59.1H156.3z M130.7,77.6V59.1h4.4v6.8h7.1v-6.8h4.3v18.4 h-4.3v-7.7h-7.1v7.7H130.7z M125.9,65c-0.8-0.8-1.6-1.4-2.4-1.8c-0.8-0.4-1.7-0.6-2.6-0.6c-1.6,0-2.8,0.5-3.8,1.6 c-1,1.1-1.5,2.5-1.5,4.1c0,1.7,0.5,3.1,1.5,4.1c1,1,2.3,1.6,3.8,1.6c0.9,0,1.9-0.2,2.8-0.6c0.9-0.4,1.9-1,2.8-1.8l-0.3,4.9 c-0.8,0.5-1.6,0.9-2.6,1.2c-0.9,0.3-1.9,0.4-2.9,0.4c-1.1,0-2.1-0.2-3.1-0.5c-1-0.3-1.9-0.8-2.8-1.5c-1.2-0.9-2.1-2.1-2.7-3.4 c-0.6-1.3-0.9-2.8-0.9-4.4c0-1.4,0.2-2.6,0.7-3.8c0.5-1.2,1.1-2.3,2-3.2c0.9-0.9,1.9-1.6,3.1-2.1c1.2-0.5,2.4-0.7,3.7-0.7 c1,0,2,0.1,3,0.4c0.9,0.3,1.8,0.7,2.7,1.3L125.9,65z"
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.3,52.1l-1.8-12.6l-7.2,10.3h-0.9l-7.3-10.4l-1.8,12.6h-5.6l3.8-24.5h0.7l10.8,14.6l10.6-14.6h0.7 l3.8,24.5H104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.6,48.3H128l-1.5,3.8h-6.1L132,27.6h0.6l11.6,24.5h-6.1L136.6,48.3z M132.3,37.4l-2.7,6.7h5.4 L132.3,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.6,52.1l-3.8-7c-0.6,0-1.1,0.1-1.7,0.1c-1.2,0-2.2-0.1-3.1-0.3v7.2h-5.7V27.9h10c6.3,0,10,3.1,10,8.3 c0,3.5-1.5,6-4.1,7.4l4.6,8.5H170.6z M170.5,36.5c0-2.3-1.3-3.7-4.8-3.7H162v7.5c0.9,0.2,1.8,0.2,2.9,0.2 C168.7,40.6,170.5,39.2,170.5,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.5,52.1L195.4,40v12.2h-5.6V27.9h5.6v10.8l8.9-10.8h6.5l-9.3,11.2l9.8,13H204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.6,47.2v4.9h-16.3V27.9h16.1v4.9h-10.8v4.4h10.3v4.6h-10.3v5.4H239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M257.1,32.8h-5.4v-4.9h16.4v4.9h-5.4v19.4h-5.7V32.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.3,52.1l-1.8-12.6l-7.2,10.3h-0.9l-7.3-10.4l-1.8,12.6h-5.6l3.8-24.5h0.7l10.8,14.6l10.6-14.6h0.7 l3.8,24.5H104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.6,48.3H128l-1.5,3.8h-6.1L132,27.6h0.6l11.6,24.5h-6.1L136.6,48.3z M132.3,37.4l-2.7,6.7h5.4 L132.3,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.6,52.1l-3.8-7c-0.6,0-1.1,0.1-1.7,0.1c-1.2,0-2.2-0.1-3.1-0.3v7.2h-5.7V27.9h10c6.3,0,10,3.1,10,8.3 c0,3.5-1.5,6-4.1,7.4l4.6,8.5H170.6z M170.5,36.5c0-2.3-1.3-3.7-4.8-3.7H162v7.5c0.9,0.2,1.8,0.2,2.9,0.2 C168.7,40.6,170.5,39.2,170.5,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.5,52.1L195.4,40v12.2h-5.6V27.9h5.6v10.8l8.9-10.8h6.5l-9.3,11.2l9.8,13H204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.6,47.2v4.9h-16.3V27.9h16.1v4.9h-10.8v4.4h10.3v4.6h-10.3v5.4H239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.1,32.8h-5.4v-4.9h16.4v4.9h-5.4v19.4h-5.7V32.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.5,79c-6.3,0-10.8-4.4-10.8-10.5c0-6.1,5-10.8,11.3-10.8c6.5,0,11.2,4.3,11.2,10.2c0,4.4-2.4,6.5-4.7,6.5 c-1.5,0-2.6-0.6-3.2-1.6c-0.9,1-2.2,1.6-3.6,1.6c-3.5,0-6.1-2.6-6.1-6c0-3.4,2.6-6,6-6c1.1,0,2.1,0.3,2.9,0.9v-0.6h3.1 c-1.4-1.3-3.3-2-5.6-2c-4.4,0-8,3.5-8,7.8c0,4.3,3.2,7.4,7.6,7.4c1,0,2.1-0.2,2.7-0.4l0.6-0.2v3.1l-0.3,0.1 C92.7,78.8,91.7,79,90.5,79z M90.8,65.7c-1.7,0-2.9,1.2-2.9,2.8c0,1.7,1.1,2.9,2.8,2.9c1.8,0,2.8-1.5,2.8-3 C93.6,66.8,92.4,65.7,90.8,65.7z M96.6,70.1c0,0.4,0.1,1.2,0.8,1.2c0.6,0,1.4-0.9,1.4-3.2c0-2.2-0.8-4-2.2-5.3V70.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.1,33.7c-0.4-2.3-2.5-4.1-4.8-4.1l-8.1,0v-8.3c0-8-6.5-14.5-14.5-14.5s-14.5,6.5-14.5,14.5v8.4l-8,0 c-2.3,0-4.4,1.9-4.8,4.1l-0.1,41c-0.3,2.3,1.3,4.1,3.6,4.1l47.6-0.2c2.3,0,3.9-1.9,3.5-4.1L70.1,33.7z M30.7,21.3 c0-6.7,5.4-12.1,12.1-12.1s12.1,5.4,12.1,12.1v8.3l-24.2,0.1V21.3z M42.7,68C35.2,68,29,61.8,29,54.3c0-7.6,6.1-13.7,13.7-13.7 c7.6,0,13.7,6.1,13.7,13.7C56.5,61.8,50.3,68,42.7,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.7,42c-6.8,0-12.2,5.5-12.2,12.2c0,6.8,5.5,12.2,12.2,12.2C49.5,66.5,55,61,55,54.3 C55,47.5,49.5,42,42.7,42z M37.1,57.1c-0.2,0.4-0.7,0.4-1,0.1l0,0c-0.2-0.2-0.3-0.5-0.1-0.8c0.3-0.6,0.5-1.3,0.5-2.1 c0-0.7-0.2-1.4-0.5-2c-0.1-0.2-0.1-0.6,0.1-0.7c0.3-0.3,0.8-0.2,1,0.2c0.4,0.8,0.6,1.6,0.6,2.6C37.8,55.4,37.6,56.3,37.1,57.1z  M38.5,59.6L38.5,59.6c-0.3-0.3-0.3-0.6-0.2-0.9c0.8-1.2,1.3-2.7,1.3-4.3c0-1.5-0.4-2.9-1.2-4.1c-0.2-0.3-0.1-0.6,0.1-0.8 l0.1-0.1c0.3-0.3,0.7-0.2,0.9,0.1c0.9,1.4,1.4,3.1,1.4,4.8c0,1.9-0.6,3.6-1.6,5.1C39.3,59.8,38.8,59.9,38.5,59.6z M41.9,61.8 c-0.2,0.3-0.7,0.3-0.9,0.1l-0.2-0.2c-0.2-0.2-0.3-0.6-0.1-0.8c1.4-1.8,2.2-4,2.2-6.4c0-2.3-0.7-4.4-2-6.2 c-0.2-0.3-0.2-0.6,0.1-0.8l0.2-0.2c0.3-0.2,0.7-0.2,0.9,0.1c1.4,2,2.3,4.4,2.3,7.1C44.4,57.2,43.4,59.8,41.9,61.8z M44.2,64.1 c-0.2,0.3-0.6,0.3-0.9,0.1l-0.2-0.2c-0.2-0.2-0.3-0.6-0.1-0.8c1.9-2.4,3-5.4,3-8.6c0-3.1-1-6-2.8-8.3c-0.2-0.3-0.2-0.6,0.1-0.8 l0.3-0.2c0.3-0.2,0.7-0.2,0.9,0.1c2,2.6,3.1,5.8,3.1,9.3C47.6,58.1,46.4,61.4,44.2,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.1,33.7c-0.4-2.3-2.5-4.1-4.8-4.1l-8.1,0v-8.3c0-8-6.5-14.5-14.5-14.5s-14.5,6.5-14.5,14.5v8.4l-8,0 c-2.3,0-4.4,1.9-4.8,4.1l-0.1,41c-0.3,2.3,1.3,4.1,3.6,4.1l47.6-0.2c2.3,0,3.9-1.9,3.5-4.1L70.1,33.7z M30.7,21.3 c0-6.7,5.4-12.1,12.1-12.1s12.1,5.4,12.1,12.1v8.3l-24.2,0.1V21.3z M42.7,68C35.2,68,29,61.8,29,54.3c0-7.6,6.1-13.7,13.7-13.7 c7.6,0,13.7,6.1,13.7,13.7C56.5,61.8,50.3,68,42.7,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.7,6.1c-8.4,0-15.3,6.9-15.3,15.3V30c0.1,0,3.1-0.1,4-0.1v-8.6c0-6.2,5.1-11.3,11.3-11.3S54,15.1,54,21.3 v9.4c1.3-0.1,2.7,2.7,4,2.7V21.3C58,12.9,51.2,6.1,42.7,6.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.3,52.1l-1.8-12.6l-7.2,10.3h-0.9l-7.3-10.4l-1.8,12.6h-5.6l3.8-24.5h0.7l10.8,14.6l10.6-14.6h0.7 l3.8,24.5H104.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096043157699795022250000004068901861841184404_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096043157699795022250000004068901861841184404_)"
    },
    d: "M136.6,48.3H128l-1.5,3.8h-6.1 L132,27.6h0.6l11.6,24.5h-6.1L136.6,48.3z M132.3,37.4l-2.7,6.7h5.4L132.3,37.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017486266860329870700000013543446538760091544_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017486266860329870700000013543446538760091544_)"
    },
    d: "M170.6,52.1l-3.8-7 c-0.6,0-1.1,0.1-1.7,0.1c-1.2,0-2.2-0.1-3.1-0.3v7.2h-5.7V27.9h10c6.3,0,10,3.1,10,8.3c0,3.5-1.5,6-4.1,7.4l4.6,8.5H170.6z  M170.5,36.5c0-2.3-1.3-3.7-4.8-3.7H162v7.5c0.9,0.2,1.8,0.2,2.9,0.2C168.7,40.6,170.5,39.2,170.5,36.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049943079008641380740000013590900236203422620_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049943079008641380740000013590900236203422620_)"
    },
    d: "M204.5,52.1L195.4,40v12.2h-5.6V27.9 h5.6v10.8l8.9-10.8h6.5l-9.3,11.2l9.8,13H204.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132809924301298393270000012386736368701119646_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132809924301298393270000012386736368701119646_)"
    },
    d: "M239.6,47.2v4.9h-16.3V27.9h16.1v4.9 h-10.8v4.4h10.3v4.6h-10.3v5.4H239.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138546693529691247240000015231568526748775103_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138546693529691247240000015231568526748775103_)"
    },
    d: "M257.1,32.8h-5.4v-4.9h16.4v4.9h-5.4 v19.4h-5.7V32.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150075230594728594150000016746690884921990299_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150075230594728594150000016746690884921990299_)"
    },
    d: "M104.3,52.1l-1.8-12.6l-7.2,10.3h-0.9 l-7.3-10.4l-1.8,12.6h-5.6l3.8-24.5h0.7l10.8,14.6l10.6-14.6h0.7l3.8,24.5H104.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085941775302574877000000017716135129355053962_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085941775302574877000000017716135129355053962_)"
    },
    d: "M136.6,48.3H128l-1.5,3.8h-6.1 L132,27.6h0.6l11.6,24.5h-6.1L136.6,48.3z M132.3,37.4l-2.7,6.7h5.4L132.3,37.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010998199340350691480000004709956314943648642_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010998199340350691480000004709956314943648642_)"
    },
    d: "M170.6,52.1l-3.8-7 c-0.6,0-1.1,0.1-1.7,0.1c-1.2,0-2.2-0.1-3.1-0.3v7.2h-5.7V27.9h10c6.3,0,10,3.1,10,8.3c0,3.5-1.5,6-4.1,7.4l4.6,8.5H170.6z  M170.5,36.5c0-2.3-1.3-3.7-4.8-3.7H162v7.5c0.9,0.2,1.8,0.2,2.9,0.2C168.7,40.6,170.5,39.2,170.5,36.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059310489923840532310000000064192035176019892_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059310489923840532310000000064192035176019892_)"
    },
    d: "M204.5,52.1L195.4,40v12.2h-5.6V27.9 h5.6v10.8l8.9-10.8h6.5l-9.3,11.2l9.8,13H204.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139265704951995038730000014911201738165269434_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139265704951995038730000014911201738165269434_)"
    },
    d: "M239.6,47.2v4.9h-16.3V27.9h16.1v4.9 h-10.8v4.4h10.3v4.6h-10.3v5.4H239.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064342871636792261720000003056090397565949118_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064342871636792261720000003056090397565949118_)"
    },
    d: "M257.1,32.8h-5.4v-4.9h16.4v4.9h-5.4 v19.4h-5.7V32.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158000956182755953210000009338651270896671636_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158000956182755953210000009338651270896671636_)"
    },
    d: "M104.3,52.1l-1.8-12.6l-7.2,10.3h-0.9 l-7.3-10.4l-1.8,12.6h-5.6l3.8-24.5h0.7l10.8,14.6l10.6-14.6h0.7l3.8,24.5H104.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011721611238535059290000000527516656710704800_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011721611238535059290000000527516656710704800_)"
    },
    d: "M136.6,48.3H128l-1.5,3.8h-6.1 L132,27.6h0.6l11.6,24.5h-6.1L136.6,48.3z M132.3,37.4l-2.7,6.7h5.4L132.3,37.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021834456739471218230000010959511844377329332_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021834456739471218230000010959511844377329332_)"
    },
    d: "M170.6,52.1l-3.8-7 c-0.6,0-1.1,0.1-1.7,0.1c-1.2,0-2.2-0.1-3.1-0.3v7.2h-5.7V27.9h10c6.3,0,10,3.1,10,8.3c0,3.5-1.5,6-4.1,7.4l4.6,8.5H170.6z  M170.5,36.5c0-2.3-1.3-3.7-4.8-3.7H162v7.5c0.9,0.2,1.8,0.2,2.9,0.2C168.7,40.6,170.5,39.2,170.5,36.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066514438258704518150000008689410081297642638_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066514438258704518150000008689410081297642638_)"
    },
    d: "M204.5,52.1L195.4,40v12.2h-5.6V27.9 h5.6v10.8l8.9-10.8h6.5l-9.3,11.2l9.8,13H204.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107572199307331653860000013160967387024106937_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107572199307331653860000013160967387024106937_)"
    },
    d: "M239.6,47.2v4.9h-16.3V27.9h16.1v4.9 h-10.8v4.4h10.3v4.6h-10.3v5.4H239.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175310414327259321390000011836637205208313246_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175310414327259321390000011836637205208313246_)"
    },
    d: "M257.1,32.8h-5.4v-4.9h16.4v4.9h-5.4 v19.4h-5.7V32.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045619288105292024390000004243188264031854771_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045619288105292024390000004243188264031854771_)"
    },
    d: "M90.5,79c-6.3,0-10.8-4.4-10.8-10.5 c0-6.1,5-10.8,11.3-10.8c6.5,0,11.2,4.3,11.2,10.2c0,4.4-2.4,6.5-4.7,6.5c-1.5,0-2.6-0.6-3.2-1.6c-0.9,1-2.2,1.6-3.6,1.6 c-3.5,0-6.1-2.6-6.1-6c0-3.4,2.6-6,6-6c1.1,0,2.1,0.3,2.9,0.9v-0.6h3.1c-1.4-1.3-3.3-2-5.6-2c-4.4,0-8,3.5-8,7.8 c0,4.3,3.2,7.4,7.6,7.4c1,0,2.1-0.2,2.7-0.4l0.6-0.2v3.1l-0.3,0.1C92.7,78.8,91.7,79,90.5,79z M90.8,65.7c-1.7,0-2.9,1.2-2.9,2.8 c0,1.7,1.1,2.9,2.8,2.9c1.8,0,2.8-1.5,2.8-3C93.6,66.8,92.4,65.7,90.8,65.7z M96.6,70.1c0,0.4,0.1,1.2,0.8,1.2 c0.6,0,1.4-0.9,1.4-3.2c0-2.2-0.8-4-2.2-5.3V70.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018959989913110593320000010036592376256387726_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018959989913110593320000010036592376256387726_)"
    },
    d: "M70.1,33.7c-0.4-2.3-2.5-4.1-4.8-4.1 l-8.1,0v-8.3c0-8-6.5-14.5-14.5-14.5s-14.5,6.5-14.5,14.5v8.4l-8,0c-2.3,0-4.4,1.9-4.8,4.1l-0.1,41c-0.3,2.3,1.3,4.1,3.6,4.1 l47.6-0.2c2.3,0,3.9-1.9,3.5-4.1L70.1,33.7z M30.7,21.3c0-6.7,5.4-12.1,12.1-12.1s12.1,5.4,12.1,12.1v8.3l-24.2,0.1V21.3z  M42.7,68C35.2,68,29,61.8,29,54.3c0-7.6,6.1-13.7,13.7-13.7c7.6,0,13.7,6.1,13.7,13.7C56.5,61.8,50.3,68,42.7,68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037650208453835727540000008994773494938130335_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037650208453835727540000008994773494938130335_)"
    },
    d: "M42.7,42c-6.8,0-12.2,5.5-12.2,12.2 c0,6.8,5.5,12.2,12.2,12.2C49.5,66.5,55,61,55,54.3C55,47.5,49.5,42,42.7,42z M37.1,57.1c-0.2,0.4-0.7,0.4-1,0.1l0,0 c-0.2-0.2-0.3-0.5-0.1-0.8c0.3-0.6,0.5-1.3,0.5-2.1c0-0.7-0.2-1.4-0.5-2c-0.1-0.2-0.1-0.6,0.1-0.7c0.3-0.3,0.8-0.2,1,0.2 c0.4,0.8,0.6,1.6,0.6,2.6C37.8,55.4,37.6,56.3,37.1,57.1z M38.5,59.6L38.5,59.6c-0.3-0.3-0.3-0.6-0.2-0.9 c0.8-1.2,1.3-2.7,1.3-4.3c0-1.5-0.4-2.9-1.2-4.1c-0.2-0.3-0.1-0.6,0.1-0.8l0.1-0.1c0.3-0.3,0.7-0.2,0.9,0.1 c0.9,1.4,1.4,3.1,1.4,4.8c0,1.9-0.6,3.6-1.6,5.1C39.3,59.8,38.8,59.9,38.5,59.6z M41.9,61.8c-0.2,0.3-0.7,0.3-0.9,0.1l-0.2-0.2 c-0.2-0.2-0.3-0.6-0.1-0.8c1.4-1.8,2.2-4,2.2-6.4c0-2.3-0.7-4.4-2-6.2c-0.2-0.3-0.2-0.6,0.1-0.8l0.2-0.2c0.3-0.2,0.7-0.2,0.9,0.1 c1.4,2,2.3,4.4,2.3,7.1C44.4,57.2,43.4,59.8,41.9,61.8z M44.2,64.1c-0.2,0.3-0.6,0.3-0.9,0.1l-0.2-0.2c-0.2-0.2-0.3-0.6-0.1-0.8 c1.9-2.4,3-5.4,3-8.6c0-3.1-1-6-2.8-8.3c-0.2-0.3-0.2-0.6,0.1-0.8l0.3-0.2c0.3-0.2,0.7-0.2,0.9,0.1c2,2.6,3.1,5.8,3.1,9.3 C47.6,58.1,46.4,61.4,44.2,64.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173839147887862629420000003973677748996796307_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173839147887862629420000003973677748996796307_)"
    },
    d: "M70.1,33.7c-0.4-2.3-2.5-4.1-4.8-4.1 l-8.1,0v-8.3c0-8-6.5-14.5-14.5-14.5s-14.5,6.5-14.5,14.5v8.4l-8,0c-2.3,0-4.4,1.9-4.8,4.1l-0.1,41c-0.3,2.3,1.3,4.1,3.6,4.1 l47.6-0.2c2.3,0,3.9-1.9,3.5-4.1L70.1,33.7z M30.7,21.3c0-6.7,5.4-12.1,12.1-12.1s12.1,5.4,12.1,12.1v8.3l-24.2,0.1V21.3z  M42.7,68C35.2,68,29,61.8,29,54.3c0-7.6,6.1-13.7,13.7-13.7c7.6,0,13.7,6.1,13.7,13.7C56.5,61.8,50.3,68,42.7,68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103226328526136416480000001958065177876707503_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103226328526136416480000001958065177876707503_)"
    },
    d: "M42.7,6.1c-8.4,0-15.3,6.9-15.3,15.3V30 c0.1,0,3.1-0.1,4-0.1v-8.6c0-6.2,5.1-11.3,11.3-11.3S54,15.1,54,21.3v9.4c1.3-0.1,2.7,2.7,4,2.7V21.3C58,12.9,51.2,6.1,42.7,6.1z "
  })))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.3,52.1l-1.8-12.6l-7.2,10.3h-0.9l-7.3-10.4l-1.8,12.6h-5.6l3.8-24.5h0.7l10.8,14.6l10.6-14.6h0.7 l3.8,24.5H104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.6,48.3H128l-1.5,3.8h-6.1L132,27.6h0.6l11.6,24.5h-6.1L136.6,48.3z M132.3,37.4l-2.7,6.7h5.4 L132.3,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.6,52.1l-3.8-7c-0.6,0-1.1,0.1-1.7,0.1c-1.2,0-2.2-0.1-3.1-0.3v7.2h-5.7V27.9h10c6.3,0,10,3.1,10,8.3 c0,3.5-1.5,6-4.1,7.4l4.6,8.5H170.6z M170.5,36.5c0-2.3-1.3-3.7-4.8-3.7H162v7.5c0.9,0.2,1.8,0.2,2.9,0.2 C168.7,40.6,170.5,39.2,170.5,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.5,52.1L195.4,40v12.2h-5.6V27.9h5.6v10.8l8.9-10.8h6.5l-9.3,11.2l9.8,13H204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.6,47.2v4.9h-16.3V27.9h16.1v4.9h-10.8v4.4h10.3v4.6h-10.3v5.4H239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M257.1,32.8h-5.4v-4.9h16.4v4.9h-5.4v19.4h-5.7V32.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.3,52.1l-1.8-12.6l-7.2,10.3h-0.9l-7.3-10.4l-1.8,12.6h-5.6l3.8-24.5h0.7l10.8,14.6l10.6-14.6h0.7 l3.8,24.5H104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.6,48.3H128l-1.5,3.8h-6.1L132,27.6h0.6l11.6,24.5h-6.1L136.6,48.3z M132.3,37.4l-2.7,6.7h5.4 L132.3,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.6,52.1l-3.8-7c-0.6,0-1.1,0.1-1.7,0.1c-1.2,0-2.2-0.1-3.1-0.3v7.2h-5.7V27.9h10c6.3,0,10,3.1,10,8.3 c0,3.5-1.5,6-4.1,7.4l4.6,8.5H170.6z M170.5,36.5c0-2.3-1.3-3.7-4.8-3.7H162v7.5c0.9,0.2,1.8,0.2,2.9,0.2 C168.7,40.6,170.5,39.2,170.5,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.5,52.1L195.4,40v12.2h-5.6V27.9h5.6v10.8l8.9-10.8h6.5l-9.3,11.2l9.8,13H204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.6,47.2v4.9h-16.3V27.9h16.1v4.9h-10.8v4.4h10.3v4.6h-10.3v5.4H239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.1,32.8h-5.4v-4.9h16.4v4.9h-5.4v19.4h-5.7V32.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.5,79c-6.3,0-10.8-4.4-10.8-10.5c0-6.1,5-10.8,11.3-10.8c6.5,0,11.2,4.3,11.2,10.2c0,4.4-2.4,6.5-4.7,6.5 c-1.5,0-2.6-0.6-3.2-1.6c-0.9,1-2.2,1.6-3.6,1.6c-3.5,0-6.1-2.6-6.1-6c0-3.4,2.6-6,6-6c1.1,0,2.1,0.3,2.9,0.9v-0.6h3.1 c-1.4-1.3-3.3-2-5.6-2c-4.4,0-8,3.5-8,7.8c0,4.3,3.2,7.4,7.6,7.4c1,0,2.1-0.2,2.7-0.4l0.6-0.2v3.1l-0.3,0.1 C92.7,78.8,91.7,79,90.5,79z M90.8,65.7c-1.7,0-2.9,1.2-2.9,2.8c0,1.7,1.1,2.9,2.8,2.9c1.8,0,2.8-1.5,2.8-3 C93.6,66.8,92.4,65.7,90.8,65.7z M96.6,70.1c0,0.4,0.1,1.2,0.8,1.2c0.6,0,1.4-0.9,1.4-3.2c0-2.2-0.8-4-2.2-5.3V70.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.1,33.7c-0.4-2.3-2.5-4.1-4.8-4.1l-8.1,0v-8.3c0-8-6.5-14.5-14.5-14.5s-14.5,6.5-14.5,14.5v8.4l-8,0 c-2.3,0-4.4,1.9-4.8,4.1l-0.1,41c-0.3,2.3,1.3,4.1,3.6,4.1l47.6-0.2c2.3,0,3.9-1.9,3.5-4.1L70.1,33.7z M30.7,21.3 c0-6.7,5.4-12.1,12.1-12.1s12.1,5.4,12.1,12.1v8.3l-24.2,0.1V21.3z M42.7,68C35.2,68,29,61.8,29,54.3c0-7.6,6.1-13.7,13.7-13.7 c7.6,0,13.7,6.1,13.7,13.7C56.5,61.8,50.3,68,42.7,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.7,42c-6.8,0-12.2,5.5-12.2,12.2c0,6.8,5.5,12.2,12.2,12.2C49.5,66.5,55,61,55,54.3 C55,47.5,49.5,42,42.7,42z M37.1,57.1c-0.2,0.4-0.7,0.4-1,0.1l0,0c-0.2-0.2-0.3-0.5-0.1-0.8c0.3-0.6,0.5-1.3,0.5-2.1 c0-0.7-0.2-1.4-0.5-2c-0.1-0.2-0.1-0.6,0.1-0.7c0.3-0.3,0.8-0.2,1,0.2c0.4,0.8,0.6,1.6,0.6,2.6C37.8,55.4,37.6,56.3,37.1,57.1z  M38.5,59.6L38.5,59.6c-0.3-0.3-0.3-0.6-0.2-0.9c0.8-1.2,1.3-2.7,1.3-4.3c0-1.5-0.4-2.9-1.2-4.1c-0.2-0.3-0.1-0.6,0.1-0.8 l0.1-0.1c0.3-0.3,0.7-0.2,0.9,0.1c0.9,1.4,1.4,3.1,1.4,4.8c0,1.9-0.6,3.6-1.6,5.1C39.3,59.8,38.8,59.9,38.5,59.6z M41.9,61.8 c-0.2,0.3-0.7,0.3-0.9,0.1l-0.2-0.2c-0.2-0.2-0.3-0.6-0.1-0.8c1.4-1.8,2.2-4,2.2-6.4c0-2.3-0.7-4.4-2-6.2 c-0.2-0.3-0.2-0.6,0.1-0.8l0.2-0.2c0.3-0.2,0.7-0.2,0.9,0.1c1.4,2,2.3,4.4,2.3,7.1C44.4,57.2,43.4,59.8,41.9,61.8z M44.2,64.1 c-0.2,0.3-0.6,0.3-0.9,0.1l-0.2-0.2c-0.2-0.2-0.3-0.6-0.1-0.8c1.9-2.4,3-5.4,3-8.6c0-3.1-1-6-2.8-8.3c-0.2-0.3-0.2-0.6,0.1-0.8 l0.3-0.2c0.3-0.2,0.7-0.2,0.9,0.1c2,2.6,3.1,5.8,3.1,9.3C47.6,58.1,46.4,61.4,44.2,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.1,33.7c-0.4-2.3-2.5-4.1-4.8-4.1l-8.1,0v-8.3c0-8-6.5-14.5-14.5-14.5s-14.5,6.5-14.5,14.5v8.4l-8,0 c-2.3,0-4.4,1.9-4.8,4.1l-0.1,41c-0.3,2.3,1.3,4.1,3.6,4.1l47.6-0.2c2.3,0,3.9-1.9,3.5-4.1L70.1,33.7z M30.7,21.3 c0-6.7,5.4-12.1,12.1-12.1s12.1,5.4,12.1,12.1v8.3l-24.2,0.1V21.3z M42.7,68C35.2,68,29,61.8,29,54.3c0-7.6,6.1-13.7,13.7-13.7 c7.6,0,13.7,6.1,13.7,13.7C56.5,61.8,50.3,68,42.7,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.7,6.1c-8.4,0-15.3,6.9-15.3,15.3V30c0.1,0,3.1-0.1,4-0.1v-8.6c0-6.2,5.1-11.3,11.3-11.3S54,15.1,54,21.3 v9.4c1.3-0.1,2.7,2.7,4,2.7V21.3C58,12.9,51.2,6.1,42.7,6.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034082125845516478430000018419451719477766797_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034082125845516478430000018419451719477766797_)"
    },
    d: "M104.3,52.1l-1.8-12.6l-7.2,10.3h-0.9 l-7.3-10.4l-1.8,12.6h-5.6l3.8-24.5h0.7l10.8,14.6l10.6-14.6h0.7l3.8,24.5H104.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037653710353584620210000010059733018762081920_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037653710353584620210000010059733018762081920_)"
    },
    d: "M136.6,48.3H128l-1.5,3.8h-6.1 L132,27.6h0.6l11.6,24.5h-6.1L136.6,48.3z M132.3,37.4l-2.7,6.7h5.4L132.3,37.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026875257152678071340000009035413445423066513_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026875257152678071340000009035413445423066513_)"
    },
    d: "M170.6,52.1l-3.8-7 c-0.6,0-1.1,0.1-1.7,0.1c-1.2,0-2.2-0.1-3.1-0.3v7.2h-5.7V27.9h10c6.3,0,10,3.1,10,8.3c0,3.5-1.5,6-4.1,7.4l4.6,8.5H170.6z  M170.5,36.5c0-2.3-1.3-3.7-4.8-3.7H162v7.5c0.9,0.2,1.8,0.2,2.9,0.2C168.7,40.6,170.5,39.2,170.5,36.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152225135135490613980000007419665179612552607_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152225135135490613980000007419665179612552607_)"
    },
    d: "M204.5,52.1L195.4,40v12.2h-5.6V27.9 h5.6v10.8l8.9-10.8h6.5l-9.3,11.2l9.8,13H204.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035526673365901694600000013598163772421841048_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035526673365901694600000013598163772421841048_)"
    },
    d: "M239.6,47.2v4.9h-16.3V27.9h16.1v4.9 h-10.8v4.4h10.3v4.6h-10.3v5.4H239.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073694506524557804720000018401713954592546992_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073694506524557804720000018401713954592546992_)"
    },
    d: "M257.1,32.8h-5.4v-4.9h16.4v4.9h-5.4 v19.4h-5.7V32.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098899417794393289500000015916279351497674681_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098899417794393289500000015916279351497674681_)"
    },
    d: "M104.3,52.1l-1.8-12.6l-7.2,10.3h-0.9 l-7.3-10.4l-1.8,12.6h-5.6l3.8-24.5h0.7l10.8,14.6l10.6-14.6h0.7l3.8,24.5H104.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060743966116022080540000015795197717520451498_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060743966116022080540000015795197717520451498_)"
    },
    d: "M136.6,48.3H128l-1.5,3.8h-6.1 L132,27.6h0.6l11.6,24.5h-6.1L136.6,48.3z M132.3,37.4l-2.7,6.7h5.4L132.3,37.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111879000712474544960000013700067413132233122_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111879000712474544960000013700067413132233122_)"
    },
    d: "M170.6,52.1l-3.8-7 c-0.6,0-1.1,0.1-1.7,0.1c-1.2,0-2.2-0.1-3.1-0.3v7.2h-5.7V27.9h10c6.3,0,10,3.1,10,8.3c0,3.5-1.5,6-4.1,7.4l4.6,8.5H170.6z  M170.5,36.5c0-2.3-1.3-3.7-4.8-3.7H162v7.5c0.9,0.2,1.8,0.2,2.9,0.2C168.7,40.6,170.5,39.2,170.5,36.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119084330652340970280000003886509589546326432_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119084330652340970280000003886509589546326432_)"
    },
    d: "M204.5,52.1L195.4,40v12.2h-5.6V27.9 h5.6v10.8l8.9-10.8h6.5l-9.3,11.2l9.8,13H204.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065052948117695039190000008166165840368337582_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065052948117695039190000008166165840368337582_)"
    },
    d: "M239.6,47.2v4.9h-16.3V27.9h16.1v4.9 h-10.8v4.4h10.3v4.6h-10.3v5.4H239.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093887178538100218400000009336615852801820556_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093887178538100218400000009336615852801820556_)"
    },
    d: "M257.1,32.8h-5.4v-4.9h16.4v4.9h-5.4 v19.4h-5.7V32.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154400284176766659940000001095268786072915334_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154400284176766659940000001095268786072915334_)"
    },
    d: "M104.3,52.1l-1.8-12.6l-7.2,10.3h-0.9 l-7.3-10.4l-1.8,12.6h-5.6l3.8-24.5h0.7l10.8,14.6l10.6-14.6h0.7l3.8,24.5H104.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035517249825552721460000014474859146117102761_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035517249825552721460000014474859146117102761_)"
    },
    d: "M136.6,48.3H128l-1.5,3.8h-6.1 L132,27.6h0.6l11.6,24.5h-6.1L136.6,48.3z M132.3,37.4l-2.7,6.7h5.4L132.3,37.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088091578829925790300000002510427533145531838_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088091578829925790300000002510427533145531838_)"
    },
    d: "M170.6,52.1l-3.8-7 c-0.6,0-1.1,0.1-1.7,0.1c-1.2,0-2.2-0.1-3.1-0.3v7.2h-5.7V27.9h10c6.3,0,10,3.1,10,8.3c0,3.5-1.5,6-4.1,7.4l4.6,8.5H170.6z  M170.5,36.5c0-2.3-1.3-3.7-4.8-3.7H162v7.5c0.9,0.2,1.8,0.2,2.9,0.2C168.7,40.6,170.5,39.2,170.5,36.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035509596104658582880000000407163010373425312_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035509596104658582880000000407163010373425312_)"
    },
    d: "M204.5,52.1L195.4,40v12.2h-5.6V27.9 h5.6v10.8l8.9-10.8h6.5l-9.3,11.2l9.8,13H204.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092427284313440639870000009296233131953279393_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092427284313440639870000009296233131953279393_)"
    },
    d: "M239.6,47.2v4.9h-16.3V27.9h16.1v4.9 h-10.8v4.4h10.3v4.6h-10.3v5.4H239.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121994898444421476090000008547370306830765962_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121994898444421476090000008547370306830765962_)"
    },
    d: "M257.1,32.8h-5.4v-4.9h16.4v4.9h-5.4 v19.4h-5.7V32.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004536361741408302850000010522987979933365929_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004536361741408302850000010522987979933365929_)"
    },
    d: "M90.5,79c-6.3,0-10.8-4.4-10.8-10.5 c0-6.1,5-10.8,11.3-10.8c6.5,0,11.2,4.3,11.2,10.2c0,4.4-2.4,6.5-4.7,6.5c-1.5,0-2.6-0.6-3.2-1.6c-0.9,1-2.2,1.6-3.6,1.6 c-3.5,0-6.1-2.6-6.1-6c0-3.4,2.6-6,6-6c1.1,0,2.1,0.3,2.9,0.9v-0.6h3.1c-1.4-1.3-3.3-2-5.6-2c-4.4,0-8,3.5-8,7.8 c0,4.3,3.2,7.4,7.6,7.4c1,0,2.1-0.2,2.7-0.4l0.6-0.2v3.1l-0.3,0.1C92.7,78.8,91.7,79,90.5,79z M90.8,65.7c-1.7,0-2.9,1.2-2.9,2.8 c0,1.7,1.1,2.9,2.8,2.9c1.8,0,2.8-1.5,2.8-3C93.6,66.8,92.4,65.7,90.8,65.7z M96.6,70.1c0,0.4,0.1,1.2,0.8,1.2 c0.6,0,1.4-0.9,1.4-3.2c0-2.2-0.8-4-2.2-5.3V70.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001661286297136255140000003964124711417784987_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001661286297136255140000003964124711417784987_)"
    },
    d: "M70.1,33.7c-0.4-2.3-2.5-4.1-4.8-4.1 l-8.1,0v-8.3c0-8-6.5-14.5-14.5-14.5s-14.5,6.5-14.5,14.5v8.4l-8,0c-2.3,0-4.4,1.9-4.8,4.1l-0.1,41c-0.3,2.3,1.3,4.1,3.6,4.1 l47.6-0.2c2.3,0,3.9-1.9,3.5-4.1L70.1,33.7z M30.7,21.3c0-6.7,5.4-12.1,12.1-12.1s12.1,5.4,12.1,12.1v8.3l-24.2,0.1V21.3z  M42.7,68C35.2,68,29,61.8,29,54.3c0-7.6,6.1-13.7,13.7-13.7c7.6,0,13.7,6.1,13.7,13.7C56.5,61.8,50.3,68,42.7,68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043437610000450626760000006519572656502876563_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043437610000450626760000006519572656502876563_)"
    },
    d: "M42.7,42c-6.8,0-12.2,5.5-12.2,12.2 c0,6.8,5.5,12.2,12.2,12.2C49.5,66.5,55,61,55,54.3C55,47.5,49.5,42,42.7,42z M37.1,57.1c-0.2,0.4-0.7,0.4-1,0.1l0,0 c-0.2-0.2-0.3-0.5-0.1-0.8c0.3-0.6,0.5-1.3,0.5-2.1c0-0.7-0.2-1.4-0.5-2c-0.1-0.2-0.1-0.6,0.1-0.7c0.3-0.3,0.8-0.2,1,0.2 c0.4,0.8,0.6,1.6,0.6,2.6C37.8,55.4,37.6,56.3,37.1,57.1z M38.5,59.6L38.5,59.6c-0.3-0.3-0.3-0.6-0.2-0.9 c0.8-1.2,1.3-2.7,1.3-4.3c0-1.5-0.4-2.9-1.2-4.1c-0.2-0.3-0.1-0.6,0.1-0.8l0.1-0.1c0.3-0.3,0.7-0.2,0.9,0.1 c0.9,1.4,1.4,3.1,1.4,4.8c0,1.9-0.6,3.6-1.6,5.1C39.3,59.8,38.8,59.9,38.5,59.6z M41.9,61.8c-0.2,0.3-0.7,0.3-0.9,0.1l-0.2-0.2 c-0.2-0.2-0.3-0.6-0.1-0.8c1.4-1.8,2.2-4,2.2-6.4c0-2.3-0.7-4.4-2-6.2c-0.2-0.3-0.2-0.6,0.1-0.8l0.2-0.2c0.3-0.2,0.7-0.2,0.9,0.1 c1.4,2,2.3,4.4,2.3,7.1C44.4,57.2,43.4,59.8,41.9,61.8z M44.2,64.1c-0.2,0.3-0.6,0.3-0.9,0.1l-0.2-0.2c-0.2-0.2-0.3-0.6-0.1-0.8 c1.9-2.4,3-5.4,3-8.6c0-3.1-1-6-2.8-8.3c-0.2-0.3-0.2-0.6,0.1-0.8l0.3-0.2c0.3-0.2,0.7-0.2,0.9,0.1c2,2.6,3.1,5.8,3.1,9.3 C47.6,58.1,46.4,61.4,44.2,64.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147909413479642409640000006602178740263369907_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147909413479642409640000006602178740263369907_)"
    },
    d: "M70.1,33.7c-0.4-2.3-2.5-4.1-4.8-4.1 l-8.1,0v-8.3c0-8-6.5-14.5-14.5-14.5s-14.5,6.5-14.5,14.5v8.4l-8,0c-2.3,0-4.4,1.9-4.8,4.1l-0.1,41c-0.3,2.3,1.3,4.1,3.6,4.1 l47.6-0.2c2.3,0,3.9-1.9,3.5-4.1L70.1,33.7z M30.7,21.3c0-6.7,5.4-12.1,12.1-12.1s12.1,5.4,12.1,12.1v8.3l-24.2,0.1V21.3z  M42.7,68C35.2,68,29,61.8,29,54.3c0-7.6,6.1-13.7,13.7-13.7c7.6,0,13.7,6.1,13.7,13.7C56.5,61.8,50.3,68,42.7,68z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005267952290476213060000000223931066265524627_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.351,
    y1: 42.5197,
    x2: 268.1136,
    y2: 42.5197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004554254,
    style: {
      stopColor: "#2D5511"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7DF23"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005267952290476213060000000223931066265524627_)"
    },
    d: "M42.7,6.1c-8.4,0-15.3,6.9-15.3,15.3V30 c0.1,0,3.1-0.1,4-0.1v-8.6c0-6.2,5.1-11.3,11.3-11.3S54,15.1,54,21.3v9.4c1.3-0.1,2.7,2.7,4,2.7V21.3C58,12.9,51.2,6.1,42.7,6.1z "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.928869f7fe01a27b761064622d3eff42.svg";
export { ForwardRef as ReactComponent };